export { default } from './Chip';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Chip/index.js
// module id = 536
// module chunks = 2